import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StudentRequest, StudentAskTutor } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from '../../../core/services/error-handler.service';
import { environment } from '../../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class EmailService {
  private askTutorUrl = `${environment.msStudentApiUrl}students/askQuestion`;

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }


  public sendAskTutorEmail(content: StudentRequest.AskTutor): Observable<StudentAskTutor> {

    return this.http.post<StudentAskTutor>(this.askTutorUrl, content).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
